import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../../../components/Header';
import Footer from '../../../components/Footer';
import './RegistroMarcaPage.css';

const RegistroMarcaPage = () => {
  return (
    <>
      <Header />
      
      <div className="registro-container">
        <div className="registro-content">
          <div className="registro-left">
            <div className="registro-logo">
              <img src="/logo/Logo_Sem_Fundo.png" alt="Veridicus Logo" className="logo-img" />
              <h1 className="overlay-title">REGISTRO DE MARCA NO INPI</h1>
            </div>
          </div>
          
          <div className="registro-right">
            <div className="registro-description">
              <p className="registro-intro">
                Proteja sua marca com acompanhamento completo e seguro em todas as etapas:
              </p>
              
              <ul className="registro-services">
                <li>Pesquisa de viabilidade e definição de classes;</li>
                <li>Protocolo e acompanhamento no INPI;</li>
                <li>Defesa em oposições e exigências;</li>
                <li>Renovação e manutenção do registro; e</li>
                <li>Monitoramento de marcas semelhantes.</li>
              </ul>
              
              <p>
                Desde a análise inicial até a concessão definitiva, a Veridicus organiza todos os processos do registro de marca. 
                Prazos, exigências e documentos são monitorados automaticamente, garantindo que cada etapa seja cumprida com 
                precisão. Relatórios detalhados e alertas inteligentes mantêm sua equipe informada, assegurando que sua marca 
                esteja protegida e pronta para gerar valor estratégico, sem burocracia.
              </p>
            </div>
            
            <div className="registro-cta">
              <Link to="/fale-conosco" className="cta-button">
                Entre em contato
              </Link>
            </div>
          </div>
        </div>
        
        <div className="registro-navigation">
          <Link to="/servicos/documentos" className="nav-prev">
            ← CRIAÇÃO E GESTÃO DE DOCUMENTOS JURÍDICOS
          </Link>
          <div></div>
        </div>
      </div>
      
      <Footer />
    </>
  );
};

export default RegistroMarcaPage;